export default "__VITE_ASSET__CDqP8SLe__"